import { loadNavigation } from "~/features/navigation/redux/navigationThunks";
import { type NavigationNode, type NavigationNodeDTO } from "~/domains/navigation/types/NavigationTypes";
import type { AppDispatch } from "~/app/store";

export type NavigationProps = {
  navigation: NavigationNodeDTO[];
  flyoutNavigation?: NavigationNodeDTO[];
};

export function create(rawData: NavigationProps, dispatch: AppDispatch) {
  dispatch(loadNavigation(rawData));

  return null;
}

export type NavigationData = {
  root: NavigationNode;
  nodes: Dictionary<NavigationNode>;
};
